// "Herald of First Dawn." An exclusive title awarded to every account
// that existed when the closed beta opened. Granted server-side via the
// `is_founder` column (see schema.sql); the client only ever displays
// it when the player object carries `isFounder: true`, so it cannot be
// forged by a tampered client.
//
// FOUNDER_PICKER_SENTINEL is what we store in the same column the
// crown picker uses (`displayed_crown_avatar_id`) when a founder
// explicitly picks the founder title from the picker. PlayerTitle.jsx
// recognises this sentinel and renders the title regardless of any
// held crowns.

export const FOUNDER_TITLE_LABEL = 'Herald of First Dawn';
export const FOUNDER_TITLE_EPITHET = 'Herald of First Dawn';
export const FOUNDER_PICKER_SENTINEL = '__founder__';
